import { FormFilterComponent } from "./FormFilter.component";
import { FormFilter } from "../../../core/models/FormFilter";
import { useFormFilterViewModel } from "./UseFormFilterViewModel";

export interface Props {
    handleFilterForm: (filterForm: FormFilter) => void;
    onFilterReset: () => void;
    filterForm: FormFilter;
}

export function FilterWrapper({
    handleFilterForm,
    onFilterReset,
    filterForm
}: Props) {
    const vm = useFormFilterViewModel(
        filterForm,
        onFilterReset,
        handleFilterForm
    );
    return <FormFilterComponent {...vm} />;
}
